import React,{Component} from 'react';
import { connect } from 'react-redux';
// utils
import {
  loadIfStateAvailableInSessionStorage,
  Translations,
  convertStringToArray
} from '../../../../utils';
// constant
import { FORM_REFS } from '../../../../constants';
// restClient
import {eapiClient, aemHostClient} from '../../../../restClient';
// children
import  Dynamicform from '../../../common/Dynamicform/dynamicForm';
//action Creator
import { setAddresses } from '../../actions/actionCreator';

class FranceLawForm extends Component{
  constructor(props) {
    super(props);
    this.state = {
      countryFormData:{},
      dataReady: false,
      methodFlag: false,
      id:'',
      lid:''
    };
    this.franceFormMode = undefined;
  }

  translations = (text) => {
    return Translations(text,this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  translateWord = (word) => {
    var currentWord = Translations(word,this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArray(currentWord);
    return convertedArray;
  }

  loadPageState =()=>{
    var {caseId, productId} = this.props.match.params;
    eapiClient("/countryForms/case/" + caseId + "/product/" + productId )
    .then(({data}) => {
      this.setState({
        entityName:data.responseData.entityName,
        countryFormData:data.responseData,
        dataReady : true,
        id:data.responseData.id,
        lid:data.responseData.lid
      })

      if(data.responseData.countryFranceForm !== undefined){
        this.franceFormMode = "edit";
        this.setState({dataReady:true, methodFlag: true})
      }
    });

  }

  componentWillMount() {
    var {caseId} = this.props.match.params;
    loadIfStateAvailableInSessionStorage(this, null, () => {
      this.loadPageState();
    });

    let apiURL = "/aemData/formData/json_france-law-murcef";
    if (this.props.mode === "edit") {
      apiURL = apiURL.replace("json_add-", "json_edit-");
    }
    aemHostClient(apiURL)
    .then(({data}) => {
      this.setState({ formJson:data});
    });

    eapiClient("/addresses/case/" + caseId)
    .then(({data}) => {
      this.props.setAddresses(data.responseData);
    });

  }
  getFormData = (formData) => {
    this.setState({countryFormData:{...this.state.countryFormData, countryFranceForm:formData}
    });
  }

  onFormSubmit = (event) => {
    var countryFranceForm ={};
    var payLoad={};
    var {caseId, productId} = this.props.match.params;
    countryFranceForm = this.state.countryFormData.countryFranceForm;
    if(this.state.countryFormData.id !== undefined){
      payLoad.id = this.state.countryFormData.id;
      payLoad.lid = this.state.countryFormData.lid;
    }
    payLoad.countryFormName = "Country of Incorporation - France";
    payLoad.countryFranceForm =countryFranceForm;
    payLoad.caseId = caseId;
    payLoad.productId=productId;
    payLoad.id=this.state.id;
    payLoad.lid=this.state.lid;

    let apiURL;
    // if(this.state.methodFlag){
    //   var METHOD = 'PUT'
    //  c
    // }else {
    //   apiURL="/countryForms/"
    //   var METHOD = 'POST'
    // }
    apiURL = "/countryForms/case/" + caseId + "/product/" + productId
    eapiClient(apiURL,{
      method: "PUT",
      data: JSON.stringify(payLoad)

    })
    .then(({data}) => {
    });
    this.props.history.goBack();
  }


  onFormCancel = () => {
    this.props.history.goBack();
  }
  componentDidMount(){
    var getCurrentDropDown = window.sessionStorage.getItem("getCurrentDropDown");
    //var getCurrentDropDownValue = window.sessionStorage.getItem('key'+ getCurrentDropDown);
    window.sessionStorage.removeItem("getCurrentDropDown");
    window.sessionStorage.removeItem('key'+ getCurrentDropDown);
  }

  renderFormGroups() {
    let mode;
    let formData;

    if(this.state.countryFormData.countryFranceForm !== undefined && Object.keys(this.state.countryFormData.countryFranceForm).length > 0) {
      formData = {...this.state.countryFormData.countryFranceForm};
      mode ="edit";
    }else {
      formData = {};
      mode='';
    }

    const properties = {
      formData,
      editType: 'france-law-murcef-form',
      pathname: this.props.history.location.pathname
    };

    if (this.state.dataReady && this.state.formJson !== undefined && this.state.formJson.par.aemform_countryForm !== undefined) {
      return (
        <Dynamicform mode={mode}
        properties={properties}
        url={FORM_REFS[this.state.formJson.par.aemform_countryForm.formRef]}
        getFormData={this.getFormData}
        formTouched={true}
        formInvalid={false}
        onFormSubmit={this.onFormSubmit}
        onFormCancel={this.onFormCancel}
        history={this.props.history}
        pageState={this.state}
        lang = {this.props.lang.currentLang.lang}
        translatedData ={this.props.lang.translatedData}
        flag={this.props.lang.currentLangFlag.flag}
        />
      );
    }
  }

  render() {
    const pageTitle = this.state.formJson ? this.state.formJson.par.page_title_mainTitle : {};
    return (
      <div className="form-container">
      <div className="form-title">
      <h2 className="form-heading">{this.translations(pageTitle.pageHeading)}</h2>
      <div className="gdocs-clear-float"></div>
      <p className="pannel-sub-heading">{this.state.entityName}</p>
      <p className="form-required-desc optional-text">{this.translations(pageTitle.descriptionText)}</p>
      </div>
      <div className="gdocs-remove-line">{this.renderFormGroups()}</div>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    addresses: state.addresses,
    lang:state.lang
  }
}
const mapDispatchToProps = dispatch => {
  return {
    setAddresses: addresses => {
      dispatch(setAddresses(addresses));
    }
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(FranceLawForm);



// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CountryForms/FranceLawForm.js